
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M29.233 36.3c-1.638-1.475-2.518-4.146-2.518-4.146s4.723-2.9 6.073-12.054c.552-3.743-.613-8.29-1.35-9.54-2.263-3.837-4.884-5.383-9.338-5.301-4.132.076-7.091 1.723-9.158 5.302-1.758 3.043-1.198 5.477-.771 8.965.664 5.432 6.073 12.628 6.073 12.628s-.798 3.437-3.085 4.242c-5.206 1.832-9.062 1.832-10.99 4.242C2.338 42.928 3.205 47 3.205 47h38.56s1.254-4.145-1.156-6.652c-2.41-2.506-9.737-2.573-11.376-4.048"}}),_c('path',{attrs:{"stroke":"#234652","d":"m11.937 24.333 2.12 3.856h9.93"}}),_c('path',{attrs:{"stroke":"#234652","d":"M8.325 14.003c.482-1.928 4.916-1.35 4.916-1.35s.624 10.041.193 10.7c-.431.66-1.06 1.158-2.603.868-1.02-.191-1.832-.578-2.506-1.831-.675-1.253-.482-6.459 0-8.387ZM40.453 14.003c-.482-1.928-4.917-1.35-4.917-1.35s-.623 10.041-.193 10.7c.431.66 1.06 1.158 2.603.868 1.02-.191 1.832-.578 2.507-1.831.674-1.253.482-6.459 0-8.387Z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M43.845 45.638s1.253-4.146-1.157-6.652-9.736-2.574-11.375-4.049-2.519-4.145-2.519-4.145 5.204-2.492 6.073-12.054-1.855-15.013-10.03-15.013c-8.176 0-12.105 6.735-10.587 14.439s6.073 12.628 6.073 12.628-.797 3.437-3.085 4.242c-5.205 1.831-9.061 1.831-10.99 4.241-1.83 2.29-.963 6.363-.963 6.363"}}),_c('ellipse',{attrs:{"cx":"23.794","cy":"28.062","stroke":"#234652","stroke-width":"1.446","rx":"1.302","ry":".724"}}),_c('path',{attrs:{"stroke":"#234652","d":"M38.413 12.568S37.159 1 24.82 1 10.94 12.568 10.94 12.568"}})])
          )
        }
      }
    